import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import DpdUkCredentialsStore from "../../../../stores/credentials/shipping/dpd-uk-credentials-store";

interface IProps {
    credentialsStore: DpdUkCredentialsStore,
    vGroup: IValidationGroup,
}

const DpdUKCredentials: React.FC<IProps> = observer(({
                                                                credentialsStore,
                                                                vGroup,
                                                            }) => {
    return (
        <>
            <FormFieldLine
                required
                label='DPD UK API username'
                key='username'
                note='Your DPD UK API username'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DPD UK API password'
                key='password'
                note='Your DPD UK API password'
            >
                <Input
                    value={credentialsStore.password}
                    onChange={credentialsStore.setPassword}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DPD UK API Account number'
                key='accountNumber'
                note='Your DPD UK API Account number'
            >
                <Input
                    value={credentialsStore.accountNumber}
                    onChange={credentialsStore.setAccountNumber}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DPD UK Tax number'
                key='taxNumber'
                note='Required for international shipments only'
            >
                <Input
                    value={credentialsStore.taxNumber}
                    onChange={credentialsStore.setTaxNumber}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DPD UK Eori Number'
                key='eoriNumber'
                note='Required for international shipments only'
            >
                <Input
                    value={credentialsStore.eoriNumber}
                    onChange={credentialsStore.setEoriNumber}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DPD UK Pid Number'
                key='pidNumber'
                note='Required for international shipments only'
            >
                <Input
                    value={credentialsStore.pidNumber}
                    onChange={credentialsStore.setPidNumber}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    );
});

export default DpdUKCredentials;
